var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{staticClass:"common_select",on:{"change":_vm.onChange}},_vm._l((_vm.items),function(item,n){return _c('option',{key:n,domProps:{"value":item.value,"selected":item.selected}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }